import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared.module';

import { LayoutAuthComponent } from './auth/auth.component';
import { LayoutMainComponent } from './main/main.component';

const COMPONENTS = [
  LayoutAuthComponent,
  LayoutMainComponent,
];

@NgModule({
  imports: [SharedModule, FormsModule],
  providers: [],
  declarations: COMPONENTS,
  exports: COMPONENTS,
})
export class LayoutsModule { }
